/* RAGONA — small progressive enhancements (no dependencies) */
(function () {
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-rg-dialog-open]');
    if (open) {
      var d = document.getElementById(open.getAttribute('data-rg-dialog-open'));
      if (d && d.showModal) { d.showModal(); d._opener = open; }
      return;
    }
    var close = e.target.closest('[data-rg-dialog-close]');
    if (close) { var dlg = close.closest('dialog'); if (dlg) dlg.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('rg-dialog')) e.target.close();
  });
  document.addEventListener('close', function (e) {
    if (e.target._opener) e.target._opener.focus();
  }, true);

  // Delivery date range from working days (Mon-Sat, Sunday off)
  function addWorkingDays(date, n) {
    var d = new Date(date);
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n--; }
    return d;
  }
  function fmt(d) { return d.toLocaleDateString('en-PK', { day: 'numeric', month: 'short' }); }
  function renderEta(root) {
    (root || document).querySelectorAll('[data-rg-eta]').forEach(function (el) {
      var min = parseInt(el.dataset.min, 10), max = parseInt(el.dataset.max, 10);
      if (!(min > 0 && max >= min)) return;
      var now = new Date();
      el.textContent = ' (est. ' + fmt(addWorkingDays(now, min)) + ' – ' + fmt(addWorkingDays(now, max)) + ')';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { renderEta(); });
  else renderEta();
  document.addEventListener('shopify:section:load', function (e) { renderEta(e.target); });
  document.addEventListener('shopify:block:select', function (e) { renderEta(e.target); });
})();
